import styled from 'styled-components';

export const InvitationWrapper = styled.div`
  height: 15rem;
  width: 28rem;
  border-radius: 2rem;
  margin: 1rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  display: inline-block;
`;

export const UserInfo = styled.div`
  width: 100%;
  height: 40%;
  padding: 1rem;
  border-radius: 2rem 2rem 0 0;
  display: flex;
  .image {
    width: 20%;
    display: flex;
    margin-left: 0.5rem;
    img {
      height: 4.5rem;
      width: 4.5rem;
      border-radius: 100%;
      background: gray;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin-left: 0.5rem;
    .name {
      font-size: 1.2rem;
      font-weight: bold;
      margin: 0.3rem;
    }
    .text {
      font-size: 1.2rem;
      margin: 0.3rem;
    }
  }
`;

export const LowerInfo = styled.div`
  width: 100%;
  height: 60%;
  position: relative;
  img {
    height: 5rem;
    margin-left: 0.4rem;
  }
  .cont {
    height: 50%;
    width: 94%;
    display: flex;
    align-items: center;
    margin: 1rem;
  }
  .text {
    margin-left: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .buttons {
    position: absolute;
    right: 0.5rem;
    bottom: 2rem;
  }
`;

export const ButtonIgnore = styled.button`
  width: 8rem;
  height: 2rem;
  border-radius: 2rem;
  border: 0.1rem solid;

  i {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
`;

export const ButtonJoin = styled.button`
  width: 8rem;
  height: 2rem;
  border-radius: 2rem;
  color: white;
  background: #2680EB;

  i {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Cards/InvitationCard/components/styles.js